import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import {
  ENV_AUTH0_AUDIENCE,
  ENV_AUTH0_CACHE_LOCATION,
  ENV_AUTH0_CLIENT_ID,
  ENV_AUTH0_DOMAIN,
  ENV_ENABLE_DASHBOARD,
} from "../env";
import { ROUTES } from "../routes/routes";
import { parseSafeHttpUrl } from "@/utils";

const DEFAULT_POST_LOGIN_ROUTE = ENV_ENABLE_DASHBOARD
  ? ROUTES.DASHBOARD
  : ROUTES.PROFILE_SETTINGS;

const sanitizeReturnToPath = (returnTo: unknown): string => {
  const parsed = parseSafeHttpUrl(returnTo, window.location.origin);
  // Prevent invalid, cross-origin, protocol-relative, and malformed redirects.
  if (
    !parsed ||
    parsed.origin !== window.location.origin ||
    !parsed.pathname.startsWith("/") ||
    parsed.pathname.startsWith("//")
  ) {
    return DEFAULT_POST_LOGIN_ROUTE;
  }

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
};

export default function Auth0ProviderWithNavigate({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <Auth0Provider
      domain={ENV_AUTH0_DOMAIN}
      clientId={ENV_AUTH0_CLIENT_ID}
      cacheLocation={ENV_AUTH0_CACHE_LOCATION}
      useRefreshTokens={true}
      authorizationParams={{
        audience: ENV_AUTH0_AUDIENCE,
        redirect_uri: `${window.location.origin}${ROUTES.CALLBACK}`,
      }}
      onRedirectCallback={(appState) => {
        if (window.opener) {
          window.close();
          return;
        }

        navigate(sanitizeReturnToPath(appState?.returnTo), {
          replace: true,
        });
      }}
    >
      {children}
    </Auth0Provider>
  );
}
